import type { ReportAnalyzeParams } from '../types';

export const parseReportUrl = (rawUrl: string): ReportAnalyzeParams => {
  const trimmed = rawUrl.trim();
  if (!trimmed) return { url: '' };
  let parsed: URL | null = null;
  try {
    parsed = new URL(trimmed);
  } catch {
    try {
      parsed = new URL(`https://${trimmed}`);
    } catch {
      return { url: trimmed };
    }
  }
  const parts = parsed.pathname.split('/').filter(Boolean);
  const reportIdx = parts.findIndex((p) => p === 'report');
  const reportId = reportIdx >= 0 ? parts[reportIdx + 1] : undefined;
  const lang = parts[0] && parts[0].length <= 5 ? parts[0] : undefined;
  const agentId = parsed.searchParams.get('agentId') || undefined;
  return { url: trimmed, reportId, agentId, lang };
};
